module.exports = __webpack_public_path__ + "static/img/zt1-pic3.72ac58d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/zt1-pic3.jpg
// module id = Psff
// module chunks = 171